module.exports = __webpack_public_path__ + "static/media/carousel_cheese_2.a9006a6e.jpg";